import type { Metadata } from "next";
import { StaticPage } from "@/components/static-page";

export const metadata: Metadata = {
  title: "Chính sách bảo mật",
  description:
    "Cách Finzone Network thu thập, sử dụng và bảo vệ dữ liệu của người dùng.",
  alternates: { canonical: "/bao-mat" },
};

export default function Page() {
  return (
    <StaticPage
      title="Chính sách bảo mật"
      eyebrow="Quyền riêng tư"
      description="Finzone tôn trọng dữ liệu của bạn. Trang này mô tả những gì chúng tôi thu thập, vì sao và bạn kiểm soát thế nào."
    >
      <h2>Dữ liệu chúng tôi thu thập</h2>
      <ul>
        <li>
          <strong>Phân tích truy cập</strong> ẩn danh: trình duyệt, thiết bị, trang đã xem,
          thời gian trên trang. Dùng để cải thiện nội dung, không xác định cá nhân.
        </li>
        <li>
          <strong>Email</strong> khi bạn chủ động đăng ký newsletter. Dùng để gửi bản tin sáng,
          không bán cho bên thứ ba.
        </li>
        <li>
          <strong>Cookie</strong> lưu sở thích chế độ tối/sáng, không theo dõi xuyên trang.
        </li>
      </ul>

      <h2>Bên thứ ba</h2>
      <p>
        Chúng tôi sử dụng Cloudflare để tăng tốc và bảo vệ trang. Cloudflare lưu log kết nối tạm
        thời theo chính sách của họ. Khi bạn click các link tới Telegram, Zalo, Facebook,
        các nền tảng đó áp dụng chính sách riêng — chúng tôi không kiểm soát.
      </p>

      <h2>Quyền của bạn</h2>
      <ul>
        <li>Yêu cầu hủy đăng ký newsletter qua link unsubscribe trong mỗi email.</li>
        <li>Yêu cầu xoá email đã lưu bằng cách gửi tin tới <a href="/lien-he">trang Liên hệ</a>.</li>
        <li>Tắt cookie trong cài đặt trình duyệt — không ảnh hưởng đến đọc tin.</li>
      </ul>

      <h2>Trẻ em</h2>
      <p>
        Trang dành cho người từ 16 tuổi trở lên. Chúng tôi không cố ý thu thập dữ liệu của trẻ em
        dưới độ tuổi này.
      </p>

      <h2>Cập nhật</h2>
      <p>
        Khi chính sách thay đổi, chúng tôi cập nhật phiên bản và ghi rõ ngày tại cuối trang.
        Phiên bản hiện tại: 31/05/2026.
      </p>
    </StaticPage>
  );
}
